<template>
    <div class="page download-list">

        <list-skeleton v-if="loading" style="margin-bottom: 100vh"></list-skeleton>

        <div v-else>
            <div class="search">
                <van-search ref="search_input" v-model="value" show-action @search="onSearch" @cancel="onCancel" placeholder="搜一搜">
                    <template slot="action">
                        <div class="search-list-action" @click="onSearch">搜索</div>
                    </template>
                </van-search>
            </div>

            <div class="tags">
                <van-tabs :swipeable="true" v-model="category_index" @click="changeCategory">
                    <van-tab :title-class="'course-list-category-title'" v-for="(item,index) in categories" :key="index" :title="item.name" ></van-tab>
                </van-tabs>
                <div class="clear"></div>
            </div>

            <van-list v-if="list.length > 0" class="download-list-section">
                <van-cell is-link class="knowledge-list-sidebar-section-title" v-for="item in list" :key="item.id" :title="item.title">
                    <template slot="icon">
                        <img v-if="item.type_text == '图文'" src="/static/two/download_article.svg" alt="">
                        <img v-else-if="item.type_text == 'PDF'" src="/static/two/download_pdf.svg" alt="">
                        <img v-else src="/static/third/icon_course_download_pic.svg" alt="" style="margin-left: -5px">
                    </template>
                    <template slot="title">
                        <span class="download-list-section-title" @click="downloadItem(item)">{{item.title}}</span>
                    </template>
                    <template slot="label">
                        <span class="download-list-section-label">
                            {{item.created_at}}
                            <span style="margin-left: 8px" v-if="item.type_text == '图文'">{{item.view_count}}人阅读</span>
                            <span style="margin-left: 8px" v-else>{{item.download_count}}人下载</span>
                            <span style="margin-left: 8px" @click="favorite(item)">
                                <img v-if="item.isFavorite" src="/static/two/download_favorite.svg" alt="">
                                <img v-else src="/static/two/download_unfavorite.svg" alt="">
                                <span v-if="item.isFavorite">已收藏</span>
                                <span v-else>收藏</span>
                            </span>
                        </span>
                    </template>
                    <template slot="right-icon">
                        <img @click="downloadItem(item)" v-if="item.isDownload && item.type_text != '图文'" style="margin-right: 10px" src="/static/two/downloaded.svg" alt="">
                        <img @click="downloadItem(item)" v-else-if="!item.isDownload && item.type_text != '图文'" style="margin-right: 10px" src="/static/two/download.svg" alt="">
                        <div @click="downloadItem(item)" v-else></div>
                    </template>
                </van-cell>
            </van-list>

            <van-empty v-else description="" image="/static/img/pic_blank_content.svg" >
                <template slot="description">
                    <div style="text-align: center">没有更多了</div>
                    <div style="text-align: center">博医荟持续更新中…</div>
                    <div style="text-align: center;margin-top: 10px">先看看其他内容吧！</div>
                    <div style="text-align: center;margin-top: 24px">
                        <van-button color="#D3172E" round size="small" style="width: 120px" :to="'/'">
                            返回首页
                        </van-button>
                    </div>
                </template>
            </van-empty>

            <van-dialog class="share" v-model="showShareDialog" :showConfirmButton="false">
                <div class="share-img">
                    <img :src="current_item.link" style="width: 100%" alt="">
                </div>
                <div style="font-family: PingFangSC-Regular;font-size: 14px;color: #FFFFFF;text-align: center;">可长按图片保存到相册</div>
                <div class="share-cancel-btn" @click="showShareDialog = false">
                    <img src="/static/img/course/icon_course_share_close.svg" alt="">
                </div>
            </van-dialog>

            <van-dialog width="345" v-model="showEmailVisible" show-cancel-button @cancel="emailInputValue=''" @confirm="sendEmail">
                <template slot="title">
                    <div>请填写邮箱</div>
                </template>
                <template slot="default">
                    <div class="text-center" style="margin-top: 20px">请填写邮箱，资料将发送至您的邮箱里</div>
                    <div class="position-input-box">
                        <van-field
                            label-class="position-title"
                            input-align="left"
                            v-model="emailInputValue"
                            name="请填写邮箱"
                            placeholder="请填写邮箱"
                            ref="savePositionInput"
                            :rules="[{ required: true }]"
                        />
                    </div>
                </template>
            </van-dialog>
        </div>

    </div>
</template>
<script>
    import Interface from "@/util/interface"
    import listSkeleton from "@/skeleton/listSkeleton"
    export default {
        name: 'download-list',
        components :{
            'list-skeleton' : listSkeleton
        },
        data() {
            return {
                value: "",
                active: "",
                banners: [],
                categories: [],
                categories_child:[],
                recommend:[],
                list:[],
                column:[],
                loading:true,
                showEmailVisible:false,
                current_item : {},
                emailInputValue:"",
                showShareDialog : false,
                user:{},
                searchInfo :{},
                category_index:"0"
            }
        },
        methods: {
            fetch(scene){
                 if(scene==='index'){
                     let params = {
                         category_id : this.category_id,
                         pageSize:999,
                         ...this.searchInfo
                     }
                     if(this.value != ""){
                         params.category_id = 0
                         params.title = this.value
                     }
                     Interface.getData('get', Interface.download.list,params).then((res) => {
                         if(res.data.list){
                             this.list = res.data.list
                         }else{
                             this.list = []
                         }
                         setTimeout(()=>{this.loading = false;},500)
                     })
                 } else if (scene === 'category') {
                     Interface.getData('get', Interface.download.category).then((res) => {
                         this.categories = res.data
                         this.categories.unshift({name:"推荐",id:0})
                         if(this.categories.length < 5){
                             for(let i=999;i<= (1007 - this.categories.length);i++){
                                 this.categories.push({name:"",id:i})
                             }
                         }
                     })
                 }
            },
            async getDetailDownload(id){
                await Interface.getData('get', Interface.download.download+'/'+id).then((res) => {
                    return res
                })
            },
            goArticle(item){
                if(item.type == 1){
                    this.$router.push({'name':'article-detail',params:{id:item.content_id},query:{content_type:6}})
                }else{
                    this.$router.push({'name':'article-column',params:{id:item.content_id},query:{content_type:6}})
                }
            },
            go_video(item){
                if (item.type === 1){
                    this.$router.push({name:'video-detail',params: { id: item.content_id },query:{content_type:6}})
                }else{
                    this.$router.push({'name':'video-column',params:{id:item.content_id},query:{content_type:6}})
                }
            },
            favorite(item){
                Interface.getData('get', Interface.download.favorite+item.id).then((res) => {
                    if(res.code == 0){
                        item.isFavorite = !item.isFavorite
                    }
                })
            },
            async downloadItem(item){
                if(item.type_text == 'PDF'){

                    var u = navigator.userAgent;
                    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                    if (isiOS) {
                        if(item.filesize < 20480){
                            await this.getDetailDownload(item.id)
                            item.download_count += 1
                            window.location.href = item.link
                            return
                        }
                    }
                    this.showEmailVisible = true
                    this.current_item = item
                }else if(item.type_text == '图文'){
                    this.$router.push({name:"download-detail",params:{id:item.id}})
                }else{
                    this.showShareDialog = true
                    this.current_item = item
                }
            },
            sendEmail(){
                let params = {
                    id : this.current_item.id,
                    email : this.emailInputValue
                }
                localStorage.setItem("email",params.email)
                Interface.getData('post', Interface.download.email,params).then((res) => {
                    if(res.code == 0){
                        this.$dialog.alert({
                            title: '提示',
                            message: '已经记录您的邮箱 , 稍后将发送文件到您的邮箱中',
                            confirmButtonText: "确认"
                        })
                    }
                })
            },
            onSearch(){
                this.searchInfo.title = this.value
                this.fetch('index')
            },
            onCancel() {
                this.searchInfo = {}
                this.fetch('index')
            },
            changeCategory(){
                this.page = 1
                this.category_id = this.categories[this.category_index].id
                this.fetch('index')
            },
        },
        created() {
            this.fetch('index')
            this.fetch('category')
            let email = localStorage.getItem("email")
            if (email!=null){
                this.emailInputValue = email
            }
            Interface.getShareInfo(this,"指南共识","","手机里的医学资料包，随时查随时用", 45)
            sessionStorage.removeItem("search_data")

            let source_type = Interface.getUrl(window.location.href)
            if (source_type) {
                Interface.mFootPrint(0, 45,'', '', source_type, '指南共识')
            } else {
                Interface.mFootPrint('',45,'','',0, '指南共识')
            }
        },
    }
</script>
<style lang="scss">
    @import "./index";
</style>



// WEBPACK FOOTER //
// src/views/download/list/index.vue